import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import Multiselect from 'vue-multiselect'
import { useVuelidate } from '@vuelidate/core'
import { maxLength, numeric, alphaNum, required } from '@vuelidate/validators'

import BaseButton from '@/components/BaseButton'
import Pager from '@/components/PagerComponent'

import { ResponseCodes } from '@/enums/response-codes.enum'
import { TransactionTypes } from '@/enums/transaction-types.enum'

import { useToast } from 'vue-toast-notification';

export default {

  components: {
    Multiselect,
    BaseButton,
    Pager
  },

  setup () {
    return { v$: useVuelidate() }
  },

  data () {
    return {
      criterias: {
        selectedIdDistributeur: '',
        // selectedNumCard: '',
        selectedCardId: '',
        selectedNumAut: '',
        selectedIdMarchand: '',
        selectedStartDate: dayjs().format('YYYY-MM-DD'),
        selectedStartTime: '00:00:01',
        selectedEndDate: dayjs().format('YYYY-MM-DD'),
        selectedEndTime: '23:59:59',
        selectedTypeTransaction: [],
        selectedCodeRetour: [],
        selectedAmount: '',
        selectedCurrencyCode: ''
      },
      dateRange: 90,
      displayedAuthorizations: [],
      distributors: [],
      responseErr: '',
      error: false,
      validationError: false,
      isProcessing: false,
      transactionTypes: TransactionTypes,
      responseCodes: ResponseCodes,
      isDistributorLocked: false
    }
  },

  created () {
     if(this.$store.state.authorizations.invalidData) {
      const $toast = useToast();
      $toast.open({
        message: this.$i18n.t('error.' + this.$store.state.authorizations.invalidData),
        type:'default',
        position: 'bottom',
        duration: 5000,
        dismissible:true
      });
    }
    this.$store.dispatch('authorizations/resetInvalidData')
    const user = JSON.parse(sessionStorage.getItem('user'))
    this.getDistributors(user)
    this.getCriterias(user)
  },

  updated () {
    this.$nextTick(function () {
      if (this.criterias.selectedIdDistributeur !== '' && this.criterias.selectedCardId === '') {
        // this.dateRange = 1
        this.dateRange = 90
      } else {
        this.dateRange = 90
      }
    })
  },

  methods: {
    search () {
      this.validationError = this.v$.$invalid

      if (!this.validationError) {
        this.$store.dispatch('authorizations/setCriterias', this.criterias)
        this.getAuthorizations()
      }
    },

    async getDistributors (user) {
      this.distributors = Object.keys(user.comProductsMap).sort()
      if (user.ihmDistribRef) {
        this.criterias.selectedIdDistributeur = user.ihmDistribRef
        this.isDistributorLocked = true
      }
    },

    async getCriterias (user) {
      if(this.$store.state.authorizations.criterias && this.$store.state.authorizations.authorizations.length > 0) {
        this.criterias = this.$store.state.authorizations.criterias
      }
      if (user.ihmDistribRef) { // Au cas où le distributeur serait changé
        this.criterias.selectedIdDistributeur = user.ihmDistribRef
      }
    },

    async getAuthorizations () {
      this.isProcessing = true
      this.error = false

      await this.$store.dispatch('authorizations/reset')
      await this.$store.dispatch('authorizations/search', {
        idDistributeur: this.criterias.selectedIdDistributeur,
        // numCarte: this.criterias.selectedNumCard,
        cardId: this.criterias.selectedCardId,
        numAut: this.criterias.selectedNumAut,
        idMarchand: this.criterias.selectedIdMarchand,
        transDateDebut: this.criterias.selectedStartDate.concat('T'.concat(this.criterias.selectedStartTime.length === 5 ? this.criterias.selectedStartTime.concat(':00') : this.criterias.selectedStartTime)),
        transDateFin: this.criterias.selectedEndDate.concat('T'.concat(this.criterias.selectedEndTime.length === 5 ? this.criterias.selectedEndTime.concat(':00') : this.criterias.selectedEndTime)),
        typeTransactions: this.criterias.selectedTypeTransaction,
        codeRetours: this.criterias.selectedCodeRetour,
        amount: this.criterias.selectedAmount,
        currencyCode: this.criterias.selectedCurrencyCode
      }).then(
        () => {
          this.isProcessing = false
        },
        error => {
          this.isProcessing = false
          this.error = true
          this.responseErr = error || 'BAD_REQUEST'
        }
      )
    },

    downloadCSV () {
      const csv = this.loadCSV()
      const hiddenElement = document.createElement('a')
      hiddenElement.href = 'data:application/csv;charset=UTF-8,%EF%BB%BF' + encodeURIComponent(csv)
      hiddenElement.target = '_blank'
      hiddenElement.download = dayjs().format('YYYYMMDD_HHmmss').concat('.csv')
      hiddenElement.click()
    },

    loadCSV () {
      const allColumns = (this.$store.state.authorizations.authorizations[0] && Object.keys(this.$store.state.authorizations.authorizations[0])) || []
      const keys = this.filterColumns(allColumns)
      let csv = keys.map(this.getCSVHeaderLabel).join(';') + '\n'
      for (const line of this.$store.state.authorizations.authorizations) {
        csv += keys.map(key => this.formatCSVValue(key, line[key])).join(';') + '\n'
      }
      return csv
    },

    filterColumns (columnsArray) {
      return columnsArray.filter(function (ele) { return ele !== 'oriAuthorization' })
    },

    getCSVHeaderLabel (headerName) {
      return this.$i18n.t('label.authorization.detail.'.concat(headerName))
    },

    formatCSVValue (key, value) {
      switch (key) {
        case 'dateMoveUp':
        case 'dateTransaction':
        case 'oriDateTransaction':
          return value ? this.$filters.date(value) : value
        case 'dateTransmissionTransaction':
          return value ? this.$filters.dateTransmission(value) : value
        case 'amount':
        case 'solde':
        case 'actualAmount':
        case 'cardholderAmount':
          return value ? this.$filters.amount(value) : value
        case 'complementAmount':
          return value ? this.$filters.amountObject(value) : value
        default:
          return value
      }
    },

    status (validation) {
      return {
        'validation-error': validation.$invalid && this.validationError
      }
    },

    getResponseCodeInfo (responseCode) {
      return this.$i18n.t('label.authorization.codeRp._'.concat(responseCode))
    },

    async showDetails (authorization) {
      this.$store.dispatch('authorizations/setAuthorizationDetail', authorization)
      this.$router.push({ name: 'authorization-detail' })
    },

    reset () {
      this.$store.dispatch('authorizations/reset')
      this.$store.dispatch('authorizations/resetCriterias')
      this.validationError = false
      this.error = false
      if (!this.isDistributorLocked) {
        this.criterias.selectedIdDistributeur = ''
      }
      // this.criterias.selectedNumCard = ''
      this.criterias.selectedCardId = ''
      this.criterias.selectedNumAut = ''
      this.criterias.selectedIdMarchand = ''
      this.criterias.selectedStartDate = dayjs().format('YYYY-MM-DD')
      this.criterias.selectedStartTime = '00:00:01'
      this.criterias.selectedEndDate = dayjs().format('YYYY-MM-DD')
      this.criterias.selectedEndTime = '23:59:59'
      this.criterias.selectedTypeTransaction = []
      this.criterias.selectedCodeRetour = []
      this.criterias.selectedAmount = ''
      this.criterias.selectedCurrencyCode = ''
    }
  },

  validations() {
    return {
      criterias: {
        selectedIdDistributeur: {
          oneRequired () {
            return (
              this.criterias.selectedCardId ||
              this.criterias.selectedIdDistributeur
              // this.criterias.selectedNumCard
            )
          }
        },
        // selectedNumCard: {
        //   minLength: minLength(16),
        //   maxLength: maxLength(19),
        //   numeric,
        //   oneRequired () {
        //     return (
        //       this.criterias.selectedCardId ||
        //       this.criterias.selectedIdDistributeur ||
        //       this.criterias.selectedNumCard
        //     )
        //   }
        // },
        selectedCardId: {
          maxLength: maxLength(20),
          numeric,
          oneRequired () {
            return (
              this.criterias.selectedCardId ||
              this.criterias.selectedIdDistributeur
              // this.criterias.selectedNumCard
            )
          }
        },
        selectedNumAut: {
          maxLength: maxLength(6),
          numeric
        },
        selectedIdMarchand: {
          maxLength: maxLength(7),
          alphaNum
        },
        selectedStartDate: {
          required,
          rangeMax () {
            return (
              Math.abs(dayjs(this.criterias.selectedEndDate).diff(dayjs(this.criterias.selectedStartDate), 'days')) <= this.dateRange
            )
          }
        },
        selectedStartTime: { required },
        selectedEndDate: {
          required,
          rangeMax () {
            return (
              Math.abs(dayjs(this.criterias.selectedEndDate).diff(dayjs(this.criterias.selectedStartDate), 'days')) <= this.dateRange
            )
          }
        },
        selectedEndTime: { required },
        selectedTypeTransaction: {},
        selectedCodeRetour: {},
        selectedAmount: {
          maxLength: maxLength(10),
          numeric
        },
        selectedCurrencyCode: {}
      }
    }
  }
}
